import React, { useState, useEffect, useMemo, useRef } from 'react';
import {
  Container,
  Input,
  Button,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';
import { connect } from 'react-redux';
import VenteChargeEdit from '../vente_list/VenteChargeEdit';
import VenteCommissionedToEdit from '../vente_list/VenteCommissionedToEdit';
import VentePromoteurEdit from '../vente_list/VentePromoteurEdit';
import { IVentePPTable, IAuthReduxProps } from '../../types/interfaces';
import { getVenteByIdPromise } from '../../flux/actions/venteActions';

import TableContainer from "../tables_manager/TableContainer"
import { SelectColumnFilter, NumberRangeColumnFilter, DateRangeColumnFilter } from '../tables_manager/filters';
import EditableCell from "../tables_manager/EditableCell";
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faClipboard, faExternalLinkAlt, faEye, faFileInvoice, faPen, faPhone, faTrash } from '@fortawesome/free-solid-svg-icons'
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import { E_ERROR } from '../../types/errors';
import { useAlert } from "react-alert";
import moment from "moment";
import LinesEllipsis from 'react-lines-ellipsis'
import ReactTooltip from 'react-tooltip';
import PDFLink from '../pdf/PDFLink';
import { PRIVILEGE } from '../../types/privileges';
import { constants } from '../../types/constants';
import PartsPercents from '../vente_list/PartsPercents';
import PartsPercentsGraphic from '../vente_list/PartsPercentsGraphic';

const VentePPTable = ({ 
  ventesData,
  setFilteredRows,
  showProjectColumn,
  showComColumn,
  showTitledColumn,
  showSNotaireColumn,
  allAssociationsShown,
  auth
 }: IVentePPTable) => {
  const skipResetRef = React.useRef(false);
  const history = useHistory();
  const alert = useAlert();
  const [editChargeModal, setEditChargeModal] = useState(false);
  const [editCommissionedToModal, setEditCommissionedToModal] = useState(false);
  const [editPromoteurModal, setEditPromoteurModal] = useState(false);
  const [modalEditChargeVente, setModalEditChargeVente] = useState('');
  const [modalEditCommissionedToVente, setModalEditCommissionedToVente] = useState('');
  const [modalEditPromoteurVente, setModalEditPromoteurVente] = useState('');
  const [PPModal, setPPModal] = useState(false);
  const [modalPPVente, setModalPPVente] = useState('');
  
  const [copiedFlag, setCopiedFlag] = useState(false);
  const [copiedFlag2, setCopiedFlag2] = useState(false);
  const handleCopy = (e, id = 1) => {
    let phone = (e || "").toString().replace(/ /g,'');
    if(phone.length >= 4 && phone[0] !== "0")
      phone = "+" + phone
    alert.info(`Le numéro de téléphone "${phone}" a été copié.`);
    window.navigator.clipboard.writeText(phone);
    if(id == 1){
      setCopiedFlag(true);
      setTimeout(() => setCopiedFlag(false), 2000);
    }
    else if(id == 2){
      setCopiedFlag2(true);
      setTimeout(() => setCopiedFlag2(false), 2000);
    }
  };
  
  const viewCard = (e, id) => {
    if(id !== null && id !== undefined){
      if (e.ctrlKey){
        window.open('/consultation/' + id, '_blank');
        return;
      }
      history.push({ pathname: `/consultation/${id}` })
    }
    else
      alert.error(E_ERROR.NO_VENTE_WITH_THIS_ID)
  }

  const columns = //useMemo(
    [
      {
        Header: "ID Vente",
        id: "ID Vente",
        accessor: (row, index) => row.isAssLine ? row.vente?.id : row.id,
        customExportDisplay: `$.isAssLine ? ($.vente ? $.vente.id : undefined) : $.id`,
        Cell: ({ value }) => {
          return (<a href={value !== null && value !== undefined ? (`/consultation/${value}`) : '/#'} onClick={(e) => {
            e.preventDefault();
            if(value !== null && value !== undefined){
              if (e.ctrlKey){
                window.open('/consultation/' + value,'_blank');
                return;
              }
              history.push({ pathname: `/consultation/${value}` })
            }
            else
              alert.error(E_ERROR.NO_CLIENT_WITH_THIS_ID)
          }}><button className="openLinkBtn">{value}<FontAwesomeIcon icon={faExternalLinkAlt} className="openLinkIcon" /></button></a>)
        },
        hidden: true
      },
      {
        Header: "ID Bien",
        id: "ID Bien",
        accessor: (row, index) => row.isAssLine ? row.vente?.ID_BIEN : row.ID_BIEN,
        customExportDisplay: `$.isAssLine ? ($.vente ? $.vente.ID_BIEN : undefined) : $.ID_BIEN`,
        Cell: ({ value }) => value || "-",
        hidden: true
      },
      {
        Header: "Projet",
        accessor: "PROJET",
        hidden: !showProjectColumn
      },
      {
        Header: "Désignation",
        id: "Désignation",
        accessor: row => row.isAssLine ? `${row.vente?.DESIGNATION || ""} (${row.ETAGE === "0" ? "RDC" : `Étage ${row.ETAGE || "-"}`} ${row.POURCENTAGE}%${row.POSITION ? ` ${row.POSITION}` : ""})` : row.DESIGNATION,
        customExportDisplay: `$.isAssLine ? (($.vente && $.vente.DESIGNATION ? $.vente.DESIGNATION : "") + " (" + ($.ETAGE === "0" ? "RDC" : ("Étage " + ($.ETAGE || "-"))) + " " + $.POURCENTAGE + "%" + ($.POSITION ? (" " + $.POSITION) : "") + ")") : $.DESIGNATION`,
        // customExportDisplay: `$.isAssLine ? (($.ETAGE === "0" ? "RDC" : "Étage " + ($.ETAGE ? $.ETAGE : "-")) + " " + $.POURCENTAGE + "%" + ($.POSITION ? (" " + $.POSITION) : "")) : $.DESIGNATION`,
        // accessor: "DESIGNATION",
      },
      {
        Header: "N° Dossier",
        id: "N° Dossier",
        accessor: row => row.isAssLine ? row.vente?.NUM_DOSS : row.NUM_DOSS,
        customExportDisplay: `$.isAssLine ? ($.vente ? $.vente.NUM_DOSS : undefined) : $.NUM_DOSS`,
        filter: 'equals',
        // accessor: "NUM_DOSS",
        Cell: ({ value }) => value || "-"
      },
      {
        Header: "N°",
        accessor: "N",
        filter: 'equals',
        Cell: ({ value }) => value || value === "0" ? value : "-",
        hidden: true
      },
      {
        Header: "Chargé du bien",
        accessor: "charge_bien",
        filter: (rows, id, e) => rows.filter(t => (t.original.isAssLine ? t.original.chargeBienUserAss : t.original.chargeBienUser)?.LOGIN?.toString().toLowerCase().includes((e || "").toLowerCase())),
        sortType: (a, b, id, desc) => (a.original.isAssLine ? a.original.chargeBienUserAss : a.original.chargeBienUser)?.LOGIN > (b.original.isAssLine ? b.original.chargeBienUserAss : b.original.chargeBienUser)?.LOGIN ? 1 : -1,
        customExportDisplay: `($.isAssLine ? $.chargeBienUserAss : $.chargeBienUser) && ($.isAssLine ? $.chargeBienUserAss : $.chargeBienUser).LOGIN ? ($.isAssLine ? $.chargeBienUserAss : $.chargeBienUser).LOGIN : "-"`,
        Cell: ({ row: {original} }) => <>{(original.isAssLine ? original.chargeBienUserAss : original.chargeBienUser)?.LOGIN || "-"} {auth?.user?.privileges?.includes(PRIVILEGE.EDIT_CHARGE) ? <FontAwesomeIcon icon={faPen} className="inTableColumnBtn" title="Modifier" onClick={() => {setModalEditChargeVente(original); setEditChargeModal(true)}} /> : null}</>
      },
      {
        Header: "En Pourcentage",
        id: "En Pourcentage",
        accessor: row => (row.isAssLine || row.TYPE_VENTE !== "ASSOCIATION") ? "" : (row.associations || []).reduce((e, t) => {return e + Number(t.POURCENTAGE || 0)}, 0),
        customExportDisplay: `($.isAssLine || $.TYPE_VENTE !== "ASSOCIATION") ? "" : (($.associations || []).reduce((e, t) => {return e + Number(t.POURCENTAGE || 0)}, 0))`,
        Filter: NumberRangeColumnFilter,
        filter: 'between',
        Cell: ({ row: {original} }) => <Container className="linesConfirmationContainer">
          <Row>
            {original.TYPE_VENTE === "ASSOCIATION" && <PartsPercentsGraphic associations={original.associations} etages={original.bien?.ETAGE_ASS} />}
            {/* {original.TYPE_VENTE === "ASSOCIATION" && <Col xs="12" className="mapTooltipField text-center fullFlexCenter" style={{wordBreak: "break-word", overflow: "hidden"}}>
              {[
                {floorName: "RDC", percent: original.associations?.filter(e => e.ETAGE === "0").reduce((e, t) => t.POURCENTAGE ? e + t.POURCENTAGE : e, 0) || 0},
                {floorName: "1", percent: original.associations?.filter(e => e.ETAGE === "1").reduce((e, t) => t.POURCENTAGE ? e + t.POURCENTAGE : e, 0) || 0},
                ...(Number(original.bien?.ETAGE_ASS) >= 3 ? [{floorName: "2", percent: original.associations?.filter(e => e.ETAGE === "2").reduce((e, t) => t.POURCENTAGE ? e + t.POURCENTAGE : e, 0) || 0}] : []),
                ...(Number(original.bien?.ETAGE_ASS) >= 4 ? [{floorName: "3", percent: original.associations?.filter(e => e.ETAGE === "3").reduce((e, t) => t.POURCENTAGE ? e + t.POURCENTAGE : e, 0) || 0}] : []),
                ...(Number(original.bien?.ETAGE_ASS) >= 5 ? [{floorName: "4", percent: original.associations?.filter(e => e.ETAGE === "4").reduce((e, t) => t.POURCENTAGE ? e + t.POURCENTAGE : e, 0) || 0}] : []),
              ].map((e, key) => <div className="mapAssociationContainer" key={key}>
                <div className="mapAssociationFloor">{e.floorName}</div>
                <div className="mapAssociationBox"><div className="mapAssociationLoaded" style={{height: e.percent + "%"}}></div><div className="mapAssociationPercentText">{e.percent}%</div></div>
              </div>)}
            </Col>} */}
          </Row>
        </Container>,
      },
      {
        Header: "Pourcentage (Parts)",
        id: "Pourcentage (Parts)",
        accessor: row => (row.isAssLine || row.TYPE_VENTE !== "ASSOCIATION") ? "" : (row.associations || []).reduce((e, t) => {return e + Number(t.POURCENTAGE || 0)}, 0),
        customExportDisplay: `($.isAssLine || $.TYPE_VENTE !== "ASSOCIATION") ? "" : (($.associations || []).reduce((e, t) => {return e + Number(t.POURCENTAGE || 0)}, 0))`,
        Filter: NumberRangeColumnFilter,
        filter: 'between',
        Cell: ({ value, row: {original} }) => (original.isAssLine || original.TYPE_VENTE !== "ASSOCIATION") ? "-" : <div>{(Math.floor(value || 0) + "/" + (Number(original.bien?.ETAGE_ASS || 0) * 100) + "%")}&nbsp;<FontAwesomeIcon icon={faEye} className="inTableColumnBtn" title="Voir les pourcentages" onClick={() => {setModalPPVente(original); setPPModal(true)}} /></div>,
        hidden: true
      },
      {
        Header: "Limite Pourcentage (Parts)",
        id: "Limite Pourcentage (Parts)",
        accessor: row => (row.isAssLine || row.TYPE_VENTE !== "ASSOCIATION") ? "" : (Number(row.bien?.ETAGE_ASS || 0) * 100),
        customExportDisplay: `($.isAssLine || $.TYPE_VENTE !== "ASSOCIATION") ? "" : (Number($.bien ? $.bien.ETAGE_ASS : 0) * 100)`,
        Filter: NumberRangeColumnFilter,
        filter: 'between',
        Cell: ({ value }) => value ? `${value}%` : "-",
        hidden: true
      },
      {
        Header: "Disponibilité RDC",
        accessor: row => (row.isAssLine || row.TYPE_VENTE !== "ASSOCIATION") ? "" : Number(row.bien?.ETAGE_ASS || 0) >= 1 ? (100 - (row.associations || []).filter(e => e.ETAGE == 0).reduce((e, t) => e + Number(t.POURCENTAGE || 0), 0)) : 0,
        Filter: NumberRangeColumnFilter,
        filter: 'between',
        Cell: ({ value }) => value !== undefined && value !== "" ? `${value}%` : "-",
        hidden: true
      },
      {
        Header: "Disponibilité 1er",
        accessor: row => (row.isAssLine || row.TYPE_VENTE !== "ASSOCIATION") ? "" : Number(row.bien?.ETAGE_ASS || 0) >= 2 ? (100 - (row.associations || []).filter(e => e.ETAGE == 1).reduce((e, t) => e + Number(t.POURCENTAGE || 0), 0)) : 0,
        Filter: NumberRangeColumnFilter,
        filter: 'between',
        Cell: ({ value }) => value !== undefined && value !== "" ? `${value}%` : "-",
        hidden: true
      },
      {
        Header: "Disponibilité 2ème",
        accessor: row => (row.isAssLine || row.TYPE_VENTE !== "ASSOCIATION") ? "" : Number(row.bien?.ETAGE_ASS || 0) >= 3 ? (100 - (row.associations || []).filter(e => e.ETAGE == 2).reduce((e, t) => e + Number(t.POURCENTAGE || 0), 0)) : 0,
        Filter: NumberRangeColumnFilter,
        filter: 'between',
        Cell: ({ value }) => value !== undefined && value !== "" ? `${value}%` : "-",
        hidden: true
      },
      {
        Header: "Disponibilité 3ème",
        accessor: row => (row.isAssLine || row.TYPE_VENTE !== "ASSOCIATION") ? "" : Number(row.bien?.ETAGE_ASS || 0) >= 4 ? (100 - (row.associations || []).filter(e => e.ETAGE == 3).reduce((e, t) => e + Number(t.POURCENTAGE || 0), 0)) : 0,
        Filter: NumberRangeColumnFilter,
        filter: 'between',
        Cell: ({ value }) => value !== undefined && value !== "" ? `${value}%` : "-",
        hidden: true
      },
      {
        Header: "Disponibilité 4ème",
        accessor: row => (row.isAssLine || row.TYPE_VENTE !== "ASSOCIATION") ? "" : Number(row.bien?.ETAGE_ASS || 0) >= 5 ? (100 - (row.associations || []).filter(e => e.ETAGE == 4).reduce((e, t) => e + Number(t.POURCENTAGE || 0), 0)) : 0,
        Filter: NumberRangeColumnFilter,
        filter: 'between',
        Cell: ({ value }) => value !== undefined && value !== "" ? `${value}%` : "-",
        hidden: true
      },
      {
        Header: "Disponibilité 5ème",
        accessor: row => (row.isAssLine || row.TYPE_VENTE !== "ASSOCIATION") ? "" : Number(row.bien?.ETAGE_ASS || 0) >= 6 ? (100 - (row.associations || []).filter(e => e.ETAGE == 5).reduce((e, t) => e + Number(t.POURCENTAGE || 0), 0)) : 0,
        Filter: NumberRangeColumnFilter,
        filter: 'between',
        Cell: ({ value }) => value !== undefined && value !== "" ? `${value}%` : "-",
        hidden: true
      },
      {
        Header: "Statut Notaire",
        id: "Statut Notaire",
        accessor: (row, index) => (row.isAssLine ? row.vente : row)?.bien?.STATUT === constants.STATUT_SIGNE_NOTAIRE ? "Signé notaire" : !!(row.isAssLine ? row.vente : row)?.en_cours_signature ? "Signature en cours" : !!(row.isAssLine ? row.vente : row)?.chez_notaire ? "Signé client" : "Pas encore signé",
        // customExportDisplay: `($.isAssLine ? ($.vente ? $.vente.bien : undefined) : $.bien) && ($.isAssLine ? $.vente : $).bien.STATUT === "${constants.STATUT_SIGNE_NOTAIRE}" ? "Signé notaire" : ($.isAssLine ? $.vente : $).en_cours_signature ? "Signé client" : "Pas encore signé"`,
        Filter: SelectColumnFilter,
        filter: 'equals',
        Cell: ({ value }) => value || "-",
        hidden: true
      },
      {
        Header: "Titré",
        id: "Titré",
        accessor: (row, index) => (row.isAssLine ? row.vente?.bien : row.bien)?.disponibilite_tf === "oui" ? "Oui" : (row.isAssLine ? row.vente?.bien : row.bien)?.disponibilite_tf === "non" ? "Non" : "",
        customExportDisplay: `$.isAssLine ? ($.vente && $.vente.bien ? $.vente.bien.disponibilite_tf : undefined) : ($.bien ? $.bien.disponibilite_tf : undefined)`,
        Filter: SelectColumnFilter,
        filter: 'equals',
        className: "text-center",
        Cell: ({ value }) => value || "-",
        hidden: true
      },
      {
        Header: "Commercial",
        accessor: "COMMERCIAL",
        filter: (rows, id, e) => rows.filter(t => (t.original.isAssLine ? t.original.comUserAss : t.original.comUser)?.LOGIN?.toString().toLowerCase().includes((e || "").toLowerCase())),
        sortType: (a, b, id, desc) => (a.original.isAssLine ? a.original.comUserAss : a.original.comUser)?.LOGIN > (b.original.isAssLine ? b.original.comUserAss : b.original.comUser)?.LOGIN ? 1 : -1,
        customExportDisplay: `($.isAssLine ? $.comUserAss : $.comUser) && ($.isAssLine ? $.comUserAss : $.comUser).LOGIN ? ($.isAssLine ? $.comUserAss : $.comUser).LOGIN : "-"`,
        Cell: ({ row: {original} }) => (original.isAssLine ? original.comUserAss : original.comUser)?.LOGIN || "-",
        hidden: true
      },
      {
        Header: "Aperçus",
        className: "text-center",
        Cell: ({ row: {original} }) => (
            <Container className="actionsContainer">
                <button className="btn btn-info btn-rounded btn-sm my-0 waves-effect waves-light"
                  onClick={(e) => viewCard(e, original.isAssLine ? original.vente?.id : original.id)}
                  title="Consultation">
                  <FontAwesomeIcon icon={faEye} />
                </button>
                <PDFLink documentType={"vente"}
                  func={async () => getVenteByIdPromise((original.isAssLine ? original.vente?.id : original.id) || -1)}
                  download={false}
                  buttonText=""
                  iconSize="inherit"
                  // customClassNames="btn btn-info"
                  customButtonIcon={faFileInvoice}
                  allowPrintPreview={true}
                  htmlTitle="Voir la fiche de Vente"
                  customClassNames="btn btn-success btn-rounded btn-sm my-0 waves-effect waves-light actionButtonsSpace"
                  style={{paddingRight: ".75rem", paddingLeft: ".75rem"}} />
            </Container>
        ),
        disableSortBy: true,
      }
    ];

  React.useEffect(() => {
    // setSkipPageReset(false);
    skipResetRef.current = false;
  }, [ventesData])

  return (
    <div>
      <Container>
        <TableContainer columns={columns} data={ventesData} dataName="charges_dossiers" enableCheckBox={false} isEditable={false} setFilteredRows={setFilteredRows} SubComponent={({ row }) => <span>SubComponent: {row.id}</span>}/>
      </Container>
      <VenteChargeEdit modal={editChargeModal} setModal={setEditChargeModal} modalVente={modalEditChargeVente} />
      <VenteCommissionedToEdit modal={editCommissionedToModal} setModal={setEditCommissionedToModal} modalVente={modalEditCommissionedToVente} />
      <VentePromoteurEdit modal={editPromoteurModal} setModal={setEditPromoteurModal} modalVente={modalEditPromoteurVente} />
      <PartsPercents modal={PPModal} setModal={setPPModal} modalVente={modalPPVente} />
    </div>
  );
};

const mapStateToProps = (state: IAuthReduxProps) => ({
  auth: state.auth,
  error: state.error
});

export default connect(mapStateToProps, {})(VentePPTable);
